<template>
  <!-- مدیریت تب های اسناد -->
  <ul class="nav nav-tabs">
    <!-- منوی بستن تمام تب های باز -->
    <li
      class="
        nav-item
        rounded-top
        d-flex
        justify-content-center
        align-items-center
      "
    >
      <a title="بستن تمام سندهای باز" v-on:click="CloseAllTab">
        <i
          class="fab fa-buromobelexperte fa-3x text-secondary mx-2"
          aria-hidden="true"
        ></i>
      </a>
    </li>
    <!-- نمایش تب به تعداد تب باز -->
    <li
      v-for="(tab, index) in getTabList"
      :key="tab.TabID"
      class="nav-item rounded-top activeNav"
    >
      <a
        :href="hrefTabName(tab.TabID)"
        v-bind:id="'tab_' + tab.TabID"
        class="nav-link d-flex justify-content-between align-items-center"
        :class="{ active: index == 0 }"
        data-toggle="tab"
        v-on:click="tabActive = tab.TabID"
      >
        <!-- نمایش دکمه بستن سند -->
        <a
          v-on:click="removeTab(tab.TabID, tab.CheckChangeData)"
          v-bind:title="'بستن ' + tab.TabContentTitle"
        >
          <i
            v-if="tab.CheckChangeData == false"
            class="far fa-times-circle fa-1x-half text-info ml-2"
            aria-hidden="true"
          ></i>
          <i
            v-else
            class="far fa-times-circle fa-1x-half red-text ml-2"
            aria-hidden="true"
          ></i>
        </a>
        <!-- نمایش آیکون ذخیره سند -->
        <a
          v-if="tab.CheckChangeData != false"
          v-on:click="saveTabData(tab.TabID)"
          v-bind:title="'ذخیره ' + tab.TabContentTitle"
        >
          <i class="far fa-save fa-1x-half red-text ml-2"></i>
        </a>
        <!-- عنوان سند -->
        {{ tab.TabContentTitle }}
      </a>
    </li>
    <!-- منوی بازیابی مجدد اطلاعات پایه از سرور -->
    <li
      class="
        nav-item
        rounded-top
        d-flex
        justify-content-center
        align-items-center
        position-absolute
      "
      style="
        left: 20px;
        height: 21px;
        margin-top: 14px;
        padding: 0;
        background-color: white;
        border-color: #dee2e6 #dee2e6 #fff;
        box-shadow: rgb(0 0 0 / 40%) 0px -1px 3px;
      "
    >
      <a title="بازیابی مجدد اطلاعات پایه از سرور" v-on:click="ReloadBasicData">
        <i
          class="fas fa-cloud-download-alt fa-1x-half pink-text mx-2"
          style="margin-top: 3px; color: #e91e63 !important;"
          aria-hidden="true"
        ></i>
      </a>
    </li>
  </ul>
</template>

<script>
import { BusEvent } from "../../../../main.js";

export default {
  data() {
    return {
      tabActive: 1,
    };
  },
  props: {
    tabActiveInParent: {},
  },
  computed: {
    getTabList() {
      return this.$store.getters.getTabList;
      // this.tabActive = 1;
    },
  },
  methods: {
    // بستن تب جاری
    removeTab(tabID, CheckChangeData) {
      if (CheckChangeData == false) {
        // در محتویات تب تغییر مشاهده نشد
        // حذف تب
        this.$store.dispatch("deleteTabFromTabList", {
          tabID: tabID,
        });
        // حذف اطلاعات محلی
        // این رویداد در فراخوانی می شود Tab.vue
        BusEvent.$emit("removeLocalData", tabID);
        // انتقال فوکوس به تب قبلی
        this.ChangeTabActive(tabID - 1);
      } else {
        // در محتویات تب تغییر مشاهده شده است
        swal({
          title: "لغو تغییرات سند",
          text:
            "در سند تغییراتی مشاهده شد .\n" +
            "آیا تغییرات لغو و سند بسته شود ؟",
          icon: "warning", // success, warning, error, info
          buttons: {
            cancel: "انصراف",
            ok: "بله تغییرات لغو شود",
          },
          // content: "input",
          // closeModal: false,
          // dangerMode: true,
        }).then(async (value) => {
          if (value) {
            // حذف اطلاعات محلی
            // این رویداد در فراخوانی می شود Tab.vue
            BusEvent.$emit("removeLocalData", tabID);
            // حذف تب
            this.$store.dispatch("deleteTabFromTabList", {
              tabID: tabID,
            });
            // انتقال فوکوس به تب قبلی
            this.ChangeTabActive(tabID - 1);
          }
        });
      }
    },
    hrefTabName: function (tabID) {
      return "#doc" + tabID;
    },
    async ReloadBasicData(){
        swal({
          title: "بازیابی مجدد اطلاعات پایه از سرور",
          text: "آیا مایلید اطلاعات پایه مجدد از سرور بازیابی گردد ؟",
          icon: "warning", // success, warning, error, info
          buttons: {
            cancel: "انصراف",
            ok: "بله انجام میدهم",
          },
          // content: "input",
          // closeModal: false,
        }).then(async (value) => {
          if (value) {
            // فراخوانی رویداد بازیابی کل اطلاعات از کامپاننت AdminPanel
            let yearAcive = await this.$store.getters.getYearActive;
            BusEvent.$emit("LoadAllData", yearAcive);
          }
        });
    },
    // بستن تمام سندهای باز
    CloseAllTab(checkClose, strMessage = "") {
      // دریافت لیست تب های باز از مخزن اصلی
      var tablist = this.$store.getters.getTabList;
      // بررسی تعداد تب های باز
      var tabOpenCount = 0;
      tablist.forEach((tab) => {
        if (tab.TabContent != "Dashboard") {
          // شمارش تعداد تب های باز
          tabOpenCount++;
        }
      });
      // آیا تب بازی وجود دارد ؟
      if (tabOpenCount != 0) {
        swal({
          title: "بستن تمام سندهای باز",
          text: "آیا مایلید تمام سندهای باز ، بسته شوند ؟\nتوجه : تغییرات تمام سندها ،لغو می شود !!",
          icon: "warning", // success, warning, error, info
          buttons: {
            cancel: "انصراف",
            ok: "بله انجام میدهم",
          },
          // content: "input",
          // closeModal: false,
        }).then(async (value) => {
          if (value) {
            tablist.forEach((tab) => {
              if (tab.TabContent != "Dashboard") {
                // حذف اطلاعات محلی
                // این رویداد در فراخوانی می شود Tab.vue
                BusEvent.$emit("removeLocalData", tab.TabID);
                // حذف تب
                this.$store.dispatch("deleteTabFromTabList", {
                  tabID: tab.TabID,
                });
              }
            });
            // دریافت مجدد لیست تب ها پس از حذف تب های اضافه
            tablist = this.$store.getters.getTabList;
            // بررسی وضعیت خالی بودن لیست تب ها
            if (tablist.length == 0) {
              // ایجاد اطلاعات تب میزکار کاربر
              var tabData = {
                tabID: 0,
                tabContent: "Dashboard",
                tabContentTitle: "میزکار کاربر",
                NId: 0,
                NDocNu: 0,
                CheckChangeData: false,
                LocalData: false,
                TabAccDocData: {},
              };
              // ایجاد تب میزکار کاربر
              this.$store.commit("addTabList", tabData);
            }
            // انتقال فوکوس به تب اول
            this.ChangeTabActive(1);
            // اعلام حذف تب ها به متغییر کنترلی
            if (typeof checkClose != "object") {
              checkClose(true);
            }
          } else {
            if (typeof checkClose != "object") {
              checkClose(false);
            }
          }
        });
      } else {
        // بررسی وضعیت خالی بودن لیست تب ها
        if (tablist.length == 0) {
          // ایجاد اطلاعات تب میزکار کاربر
          var tabData = {
            tabID: 0,
            tabContent: "Dashboard",
            tabContentTitle: "میزکار کاربر",
            NId: 0,
            NDocNu: 0,
            CheckChangeData: false,
            LocalData: false,
            TabAccDocData: {},
          };
          // ایجاد تب میزکار کاربر
          this.$store.commit("addTabList", tabData);
        }
        // اعلام حذف تب ها به متغییر کنترلی
        if (typeof checkClose != "object") {
          checkClose(true);
        }
      }
    },
    // فراخوانی تابع ذخیره سند
    saveTabData(tabID) {
      // فراخوانی تابع ذخیره سند
      BusEvent.$emit("SaveTbDocInfo", tabID);
    },
    // رویداد تغییر تب فعال
    ChangeTabActive(tabID) {
      setTimeout(() => {
        // شبیه سازی رویداد کلیک تب
        $("#tab_" + tabID).trigger("click");
        // ذخیره شماره تب فعال
        this.tabActive = tabID;
      }, 50);
    },
  },
  watch: {
    tabActive: function () {
      // پاس دادن تب فعال به والد
      this.tabActiveInParent.tabID = this.tabActive;
    },
  },
  created() {
    // تعریف رویداد تغییر تب فعال
    BusEvent.$on("ChangeTabActive", this.ChangeTabActive);
    // تعریف رویداد فراخوانی تابع بستن تمام تب های باز
    BusEvent.$on("CloseAllTab", this.CloseAllTab);
  },
  beforeDestroy() {
    // حذف رویداد تغییر تب فعال
    BusEvent.$off("ChangeTabActive", this.ChangeTabActive);
    // حذف رویداد فراخوانی تابع بستن تمام تب های باز
    BusEvent.$on("CloseAllTab", this.CloseAllTab);
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/TabHeader/TabHeader.vue